import { z } from "zod";
import { MetaSchema } from "./shared";

export const tradeWithdrawalSchema = z.object({
  id: z.string().uuid(),
  transaction_type: z.string(),
  coin: z.string(),
  type: z.string().nullable(),
  value: z.string(),
  amount: z.string(),
  fee: z.string(),
  tracerKey: z.number().nullable(),
  useGGold: z.boolean().nullable(),
  useProfit: z.boolean().nullable(),
  hash: z.string().nullable(),
  created_at: z.string(),
  completedAt: z.string().nullable(),
  status: z.string(),
  description: z.string().nullable(),
});

const tradeTurnoverWithdrawSchema = z.object({
  data: z.tuple([
    z.array(tradeWithdrawalSchema),
    z.number(),
  ]),
  meta: MetaSchema.default,
});

export type TradeTurnoverWithdrawResponse = z.infer<
  typeof tradeTurnoverWithdrawSchema
>;
export type TradeWithdrawalItem = z.infer<typeof tradeWithdrawalSchema>;
export default tradeTurnoverWithdrawSchema
